module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/food-app-3-48a371fb75497e867d8b1e344d4a92ac.png";